import React, { Component } from 'react';
import _ from 'underscore';
import UserItem from '../../user/item';
import GroupItem from '../../group/item';
import { NoContent } from '../../ui';
import { contiansKeyword, userSearchMatchs, groupSearchMatchs } from '../../utils';

export default class extends Component {
    mapLocalData() {
        const { keyword } = this.props;
        const { userData, groupData } = this.props;
        let data = [];
        let data2 = [];
        let userMatchs = userSearchMatchs;
        let groupMatchs = groupSearchMatchs;

        if (keyword) {
            _.each(userData, (item) => {
                if (contiansKeyword(keyword, item, ...userMatchs)) {
                    data.push(item);
                }
            });

            _.each(groupData, (item) => {
                if (contiansKeyword(keyword, item, ...groupMatchs)) {
                    data2.push(item);
                } else {
                    let has;
                    _.each(item.users, (user) => {
                        if (!has && contiansKeyword(keyword, user, ...userMatchs)) {
                            data2.push(item);
                            has = true;
                        }
                    });
                }
            });
        }

        return {
            userData: data,
            groupData: data2
        };
    }

    render() {
        const { userData, groupData } = this.mapLocalData();
        const { onItemClick, onItemDoubleClick } = this.props;
        const itemProps = {
            onClick: onItemClick,
            onDoubleClick: onItemDoubleClick
        };

        return (
            <div className="session-list session-list-search">
                { userData.length ? <p>同事</p> : ''}
                {
                    userData.map((item, index)=>{
                        return <UserItem data={item} {...itemProps}/>
                    })
                }
                { groupData.length ? <p>讨论组</p> : ''}
                {
                    groupData.map((item, index)=>{
                        return <GroupItem data={item} {...itemProps}/>
                    })
                }
                {
                    !userData.length && !groupData.length ? <NoContent text="无搜索结果"/> : null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/session/list/search.js